export const licenseeAEVFields = {
    licenseeId: {
        name: "licensee_id",
        label: "Licensee Id",
        required: false,
    },
    companyName: {
        name: "company_name",
        label: "Company Name",
        required: true,
    },
    officerName: {
        name: "officer_name",
        label: "Officer Name",
        required: true,
    },
    officerTitle: {
        name: "officer_title",
        label: "Officer Title",
        required: false,
    },
    phone: {
        name: "phone",
        label: "Telephone",
        required: true,
    },
    fax: {
        name: "fax",
        label: "Fax",
        required: false,
    },
    federalTaxId: {
        name: "federal_tax_id",
        label: "Federal Tax Id",
        required: false,
    },
    isDeleted: {
        name: "is_deleted",
        label: "Deleted",
        required: false,
    },
    createDatetime: {
        name: "create_datetime",
        label: "Create at",
        required: false,
    },
    modifyDatetime: {
        name: "modify_datetime",
        label: "Modified at",
        required: false,
    },
    modifyUserId: {
        name: "modify_user_id",
        label: "Modified By Id",
        required: false,
    },
    modifyUserName: {
        name: "modify_user_name",
        label: "Modified By",
        required: false,
    },
}


